module.exports = __webpack_public_path__ + "static/media/tata-sky-logo.d9c6f745.png";